import React, { FC, Fragment, ReactNode, useCallback, useState } from 'react'
import colors from '@xo-union/tk-ui-colors/lib/variables.css'

import { Carousel } from '@xo-union/ui-carousel'
import { NextButton, PrevButton } from './buttons'
import { PageControl } from './page-control'
import styles from './styles.module.scss'

interface CarouselWithPageDotsProps {
  children: ReactNode
  minSlideWidth: number
  maxSlideWidth: number
  responsive?: (option: { width: number }) => number
}

interface Range {
  max: number
  min: number
}

export const CarouselWithPageDots: FC<CarouselWithPageDotsProps> = ({
  minSlideWidth,
  maxSlideWidth,
  responsive,
  children,
}) => {
  const [navigationIndex, setNavigationIndex] = useState(0)
  const [navigationRange, setNavigationRange] = useState<Range | undefined>()

  const slides = React.Children.toArray(children)

  const onCarouselNavigationIndexChange = useCallback((nextNavigationIndex: number) => {
    setNavigationIndex(nextNavigationIndex)
  }, [])

  const onCarouselNavigationRangeChange = useCallback((range: Range) => {
    setNavigationRange(range)
  }, [])

  const pages = navigationRange?.max ? navigationRange?.max + 1 : slides.length

  const props = { minSlideWidth, maxSlideWidth, responsive }

  return (
    <Fragment>
      <Carousel
        onNavigationIndexChange={onCarouselNavigationIndexChange}
        onNavigationRangeChange={onCarouselNavigationRangeChange}
        navigationIndex={navigationIndex}
        renderNextButton={NextButton}
        renderPrevButton={PrevButton}
        alignment={() => 'left'} // union enum, we don't have types exported from union.
        gutter={30}
        {...props}
      >
        {children}
      </Carousel>
      <PageControl
        className={styles.secondaryPageControlDisplay}
        pages={pages}
        current={navigationIndex}
        onPageSelected={onCarouselNavigationIndexChange}
        controlStateColors={{
          hoverStateDotBorder: colors.varNeutral200,
          selectedPageDot: colors.varBackgroundDark,
          unselectedPageDot: colors.varNeutral200,
        }}
      />
    </Fragment>
  )
}
